var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvcReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.539,
    height: 59,
    viewBox: "0 0 50.539 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.109,
    y1: 0.061,
    x2: 1.244,
    y2: 1.608,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#108fce"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_93791",
    x: 13.398,
    y: 0,
    width: 29.062,
    height: 29.137,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_93792",
    x: 0,
    y: 14.247,
    width: 35.226,
    height: 19.914,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_93793",
    x: 0,
    y: 18.075,
    width: 33.312,
    height: 19.914,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_93794",
    x: 0,
    y: 21.903,
    width: 35.226,
    height: 19.914,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_93795",
    x: 0,
    y: 25.731,
    width: 33.312,
    height: 19.914,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_93796",
    x: 13.399,
    y: 21.86,
    width: 37.14,
    height: 37.14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-statistics-report",
    transform: "translate(-4.785 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93790",
    "data-name": "Path 93790",
    d: "M37.711,15.527V39.453A1.914,1.914,0,0,1,35.8,41.367H10.914A1.914,1.914,0,0,1,9,39.453V6.914A1.914,1.914,0,0,1,10.914,5H27.183Z",
    transform: "translate(0 -0.152)",
    fill: "#fff",
    stroke: "#90ddf8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4.79, -4)",
    filter: "url(#Path_93791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93791-2",
    "data-name": "Path 93791",
    d: "M28,5v9.112a2.018,2.018,0,0,0,2.011,2.025h9.051Z",
    transform: "translate(-5.6 3)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4.79, -4)",
    filter: "url(#Path_93792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93792-2",
    "data-name": "Path 93792",
    d: "M31.748,20.914H15.479A.479.479,0,0,1,15,20.436v-.957A.479.479,0,0,1,15.479,19H31.748a.479.479,0,0,1,.479.479v.957A.479.479,0,0,1,31.748,20.914Z",
    transform: "translate(-6 3.25)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4.79, -4)",
    filter: "url(#Path_93793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93793-2",
    "data-name": "Path 93793",
    d: "M29.834,24.914H15.479A.479.479,0,0,1,15,24.436v-.957A.479.479,0,0,1,15.479,23H29.834a.479.479,0,0,1,.479.479v.957A.479.479,0,0,1,29.834,24.914Z",
    transform: "translate(-6 3.07)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4.79, -4)",
    filter: "url(#Path_93794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93794-2",
    "data-name": "Path 93794",
    d: "M31.748,28.914H15.479A.479.479,0,0,1,15,28.436v-.957A.479.479,0,0,1,15.479,27H31.748a.479.479,0,0,1,.479.479v.957A.479.479,0,0,1,31.748,28.914Z",
    transform: "translate(-6 2.9)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4.79, -4)",
    filter: "url(#Path_93795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93795-2",
    "data-name": "Path 93795",
    d: "M29.834,32.914H15.479A.479.479,0,0,1,15,32.436v-.957A.479.479,0,0,1,15.479,31H29.834a.479.479,0,0,1,.479.479v.957A.479.479,0,0,1,29.834,32.914Z",
    transform: "translate(-6 2.73)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4.79, -4)",
    filter: "url(#Path_93796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93796-2",
    "data-name": "Path 93796",
    d: "M38.7,28.3l1.174.658,1.347.016a2.317,2.317,0,0,1,1.965,1.134l.687,1.158,1.158.687a2.317,2.317,0,0,1,1.134,1.965l.016,1.347.658,1.174a2.318,2.318,0,0,1,0,2.268l-.658,1.174-.016,1.347a2.317,2.317,0,0,1-1.134,1.965l-1.158.687-.687,1.158a2.317,2.317,0,0,1-1.965,1.134l-1.347.016-1.174.658a2.318,2.318,0,0,1-2.268,0l-1.174-.658-1.347-.016a2.317,2.317,0,0,1-1.965-1.134l-.687-1.158-1.158-.687a2.317,2.317,0,0,1-1.134-1.965l-.016-1.347L28.3,38.7a2.318,2.318,0,0,1,0-2.268l.658-1.174.016-1.347a2.317,2.317,0,0,1,1.134-1.965l1.158-.687.687-1.158a2.317,2.317,0,0,1,1.965-1.134l1.347-.016,1.174-.658A2.318,2.318,0,0,1,38.7,28.3Z",
    transform: "translate(-5.6 2.86)",
    fill: "#38c20a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-checkmark_1_",
    "data-name": "icons8-checkmark (1)",
    d: "M11.462,8.986a.314.314,0,0,0-.216.095L5.823,14.5,3.535,12.217a.314.314,0,1,0-.444.444L5.6,15.17a.314.314,0,0,0,.444,0L11.69,9.524a.314.314,0,0,0-.228-.538Z",
    transform: "translate(29.368 24.313)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvcReport);
export default __webpack_public_path__ + "static/media/avc_report.5782b571979f39b0d70cd47daef6e8a9.svg";
export { ForwardRef as ReactComponent };